if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        document.addEventListener("click", e => {
        const path = e.composedPath();
        const selectorCheckout = `[name="checkout"]`;
        const target = path.find(el => {
            return el?.matches?.(selectorCheckout);
        });
        if ((e.target && e.target.closest(selectorCheckout)) || target) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
        }
        }, 1); 
    }, 3000)

    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            // console.log(MutationList)
            for (let item of MutationList) {
                if (item.target.classList.contains('predictive-search__results') || item.target.classList.contains('subtotalPrice')) {
                    handleCartDrawerFooterMutation();
                }
                if (item.target.localName === "quick-buy-drawer") {
                    document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
                }                
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)

    async function handleCartDrawerFooterMutation() {
        if (BSS_B2B) {
            const res = await BSS_B2B.storage.productStorage.load();
            if (res) {
                if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
                    BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                    ...res
                    });
                }
            }
        }
    }

}